import { FormControl, FormErrorMessage, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../inputs/Input";
import { forwardRef, useImperativeHandle } from "react";
import { Earmold } from "../../types/earmold.types";
import Select from "../inputs/Select";

type EarmoldFormProps = {
  value?: Earmold | null;
};

export type EarmoldFormHandler = {
  values: () => Partial<Earmold>;
  valid: () => Promise<boolean>;
};

const EarmoldForm = forwardRef<EarmoldFormHandler, EarmoldFormProps>(
  ({ value }: EarmoldFormProps, ref) => {
    const methods = useForm();

    useImperativeHandle(ref, () => ({
      valid: () => {
        return methods.trigger();
      },
      values: () => {
        const values = methods.getValues();
        return {
          label: values.label,
          price: values.price * 100,
          sageId: values.sageId,
          status: values.status,
        };
      },
    }));
    return (
      <FormProvider {...methods}>
        <form style={{ marginTop: "32px", marginBottom: "32px" }}>
          <Flex direction="column" gap="24px">
            <FormControl isInvalid={!!methods.formState.errors.label}>
              <Input
                id="label"
                placeholder="Nom"
                defaultValue={value?.label ?? ""}
                {...methods.register("label", {
                  required: "Ce champ est obligatoire",
                })}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.label?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!methods.formState.errors.price}>
              <Input
                id="price"
                placeholder="Prix (€)"
                type="number"
                defaultValue={value?.price ? value.price / 100 : ""}
                {...methods.register("price", {
                  required: "Ce champ est obligatoire",
                })}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.price?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!methods.formState.errors.sageId}>
              <Input
                id="sageId"
                placeholder="ID Sage"
                defaultValue={value?.sageId ?? ""}
                {...methods.register("sageId", {
                  required: "Ce champ est obligatoire",
                })}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.sageId?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!methods.formState.errors.status}>
              <Select
                id="status"
                placeholder="Statut"
                defaultValue={value?.status ?? "DRAFT"}
                {...methods.register("status", {
                  required: "Ce champ est obligatoire",
                })}
              >
                <option value="DRAFT">Brouillon</option>
                <option value="ACTIVE">Active</option>
              </Select>
              <FormErrorMessage>
                <>{methods.formState.errors?.status?.message}</>
              </FormErrorMessage>
            </FormControl>
          </Flex>
        </form>
      </FormProvider>
    );
  }
);

export default EarmoldForm;
